import styled from 'styled-components';

export const CarouselImageItemWrapper = styled.div``;
